import { type RecordId } from 'javascripts/shared-types';
import RecordFilter from './RecordFilter';

class WorkflowStatusFilter extends RecordFilter {
  statusAttribute: string;

  constructor(
    initialItems: RecordId[],
    initialOptions: [string, RecordId][] = [],
    filterOptions: { statusAttribute?: string } = {}
  ) {
    super(initialItems, initialOptions, filterOptions);
    this.statusAttribute = filterOptions.statusAttribute || 'workflowStatus';
  }

  matches(record: any) {
    return super.matches(record[this.statusAttribute]);
  }
}

export default WorkflowStatusFilter;
